<template>
    <div>
        <loader v-if="loading"/>
        <timeline id="timeline" :chartData="chartData" v-if="!loading"/>
    </div>
</template>
<script>

import Timeline from './Timeline.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;
import Loader from '@/components/Loader.vue';

const formatOfficeHolders = (data, y, colour) => 
    data
        .map(p => ({
            id: p.Id,
            name: p.DisplayName,
            shortName: p.ShortName,
            hasPortrait: p.HasPortrait,
            color: colour, 
            party: null,
            x: new Date(p.DateStart).valueOf(),
            present: p.DateEnd === null,
            x2: p.DateEnd ? new Date(p.DateEnd).valueOf() : new Date().valueOf(),
            y,
            dataLabels: {
                format: '<a href="/ParliamentaryOfficeHolder/{point.id}" class="timeline-label">{point.name}</a>'                
            }
        }));

export default {
    created() {
        this.initialiseData();
    },
    components: {
        Timeline,
        Loader
    },
    methods: {
        initialiseData() {
            this.loading = true;
            let endpoints = [
                'api/HistoricalInformation/OfficeHolders?officeType=1',
                'api/HistoricalInformation/OfficeHolders?officeType=2',
                'api/HistoricalInformation/OfficeHolders?officeType=7',
                'api/HistoricalInformation/OfficeHolders?officeType=8',
                'api/HistoricalInformation/OfficeHolders?officeType=3',
                'api/HistoricalInformation/OfficeHolders?officeType=4',
                'api/HistoricalInformation/OfficeHolders?officeType=5',
            ]
            axios.all(endpoints.map((endpoint) => axios.get(endpoint))).then(
                axios.spread(({data: clerksSenate}, 
                    {data: clerksReps},
                    {data: parliamentaryReporters},
                    {data: jointHouseSecretaries},
                    {data: parliamentaryServiceSecretaries},
                    {data: parliamentaryLibrarians},
                    {data: parliamentaryBudgetOfficers}) => {
                    this.clerksSenate = clerksSenate;
                    this.clerksReps = clerksReps;
                    this.parliamentaryReporters = parliamentaryReporters;
                    this.jointHouseSecretaries = jointHouseSecretaries;
                    this.parliamentaryServiceSecretaries = parliamentaryServiceSecretaries;
                    this.parliamentaryLibrarians = parliamentaryLibrarians;
                    this.parliamentaryBudgetOfficers = parliamentaryBudgetOfficers;
                    this.loading = false;
                })
            );
        }
    },
    computed: {
        chartData() {
            return {
                chart: {
                    spacingTop: 40,
                    height: 2000,
                    type: 'xrange',
                    inverted: true,
                    events: {
                        render: function () {
                            const chart = this
                            let {min: currentMin, max: currentMax} = chart.yAxis[0].getExtremes()
                            if (chart.chartWidth < 500 && currentMax - currentMin > 1) {
                                chart.yAxis[0].setExtremes(0, 0)
                            }
                            else if (chart.chartWidth < 500 && chart.previousWidth !== chart.chartWidth || (chart.min !== currentMin && chart.max !== currentMax )) {
                                chart.previousWidth = chart.chartWidth
                                chart.min = chart.yAxis[0].getExtremes().min;
                                chart.max = chart.yAxis[0].getExtremes().max;

                                const moveLeft = () => {
                                    let {min, max, dataMin} = chart.yAxis[0].getExtremes()
                                    if (min - 1 >= dataMin) {
                                        min -= 1
                                        max -= 1
                                    }
                                    chart.yAxis[0].setExtremes(min, max)
                                }
                                const moveRight = () => {
                                    let {min, max, dataMax} = chart.yAxis[0].getExtremes()
                                    if (max + 1 <= dataMax) {
                                        min += 1
                                        max += 1
                                    }
                                    chart.yAxis[0].setExtremes(min, max)
                                }
                                if (chart.leftArrow) {
                                    chart.leftArrow.destroy();
                                    chart.leftArrow = null;
                                }
                                if (chart.rightArrow) {
                                    chart.rightArrow.destroy();
                                    chart.rightArrow = null;
                                }
                                const renderArrows = () => {
                                    let {min, max, dataMax, dataMin} = chart.yAxis[0].getExtremes()
                                    const leftArrowUrl = 'https://cdn-icons-png.flaticon.com/512/271/271220.png'
                                    const rightArrowUrl = 'https://cdn-icons-png.flaticon.com/512/271/271228.png'
                                    const leftArrowX = chart.chartWidth - 20;
                                    if (min - 1 >= dataMin) {
                                        const leftArrow = chart.renderer.image(leftArrowUrl, 0, 5, 20, 20).attr({ zIndex: 10 })
                                        chart.leftArrow = leftArrow.on('click', moveLeft).add()
                                    }
                                    if (max + 1 <= dataMax) {
                                        const rightArrow = chart.renderer.image(rightArrowUrl, leftArrowX, 5, 20, 20).attr({ zIndex: 10 })
                                        chart.rightArrow = rightArrow.on('click', moveRight).add()
                                    }
                                }
                                renderArrows();
                            } else if (chart.previousWidth != chart.chartWidth) {
                                chart.previousWidth = chart.chartWidth;
                                if (chart.leftArrow) {
                                    chart.leftArrow.destroy();
                                    chart.leftArrow = null;
                                }
                                if (chart.rightArrow) {
                                    chart.rightArrow.destroy();
                                    chart.rightArrow = null;
                                }
                                const { dataMin, dataMax } = chart.yAxis[0].getExtremes()
                                chart.yAxis[0].setExtremes(dataMin, dataMax);
                            }
                        }                    
                    }
                },
                tooltip: {
                                  
                    backgroundColor: 'rgba(255, 255, 255, 0)',
                    shadow: false,
                    borderWidth: 0,
                    borderRadius: 0,
                    useHTML: true,
                    followPointer: true,
                    formatter: function () {
                        var todaysDate = new Date();
                        // console.log(this.point)
                        var dateIsToday = new Date(this.x2).setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0);
                        var showEndDate = dateIsToday ? 'present' : new Date(this.x2).toLocaleDateString('en-AU');
                        var tooltipMarkup = '<div class="tooltip" style="width:350px;min-height: 100px;">'
                        + (this.point.hasPortrait ? `<div style="display:inline-block;"><img src="${axios.defaults.baseURL}api/HistoricalInformation/Portrait?id=${this.point.id}" style="width: 80px;border-radius: 5px;" /></div>` : '')
                        + '<div style="vertical-align: top;display:inline-block; padding-left:10px;">' 
                         + '<p style="font-size:1.1em;font-weight:bold;white-space: normal;">' + this.point.yCategory + '</p>' 
                        + '<p style="font-size:1.1em;white-space: normal;">' + this.point.name + '</p>' 
                        + '<p style="white-space: normal; margin-bottom:0.2rem;">' + new Date(this.x).toLocaleDateString('en-AU') + ' - ' + showEndDate + '</p>'
                        + '</div>'
                        + '</div>';
                        return tooltipMarkup;
                    }, 
                },
                exporting: {
                    enabled: false,
                    sourceWidth: 2000
                },
                series: [
                    {
                        pointWidth: 30,
                        data: [
                            ...formatOfficeHolders(this.clerksSenate, 0, '#ab112d'),
                            ...formatOfficeHolders(this.clerksReps, 1, 'rgb(70, 118, 100)'),
                            ...formatOfficeHolders(this.parliamentaryReporters, 2, '#005FA8'),
                            ...formatOfficeHolders(this.jointHouseSecretaries, 3, '#235275'),
                            ...formatOfficeHolders(this.parliamentaryServiceSecretaries, 4, '#00335b'),
                            ...formatOfficeHolders(this.parliamentaryLibrarians, 5, '#a07dbc'),
                            ...formatOfficeHolders(this.parliamentaryBudgetOfficers, 6, '#008BF5')
                            ],
                        dataLabels: {
                            enabled: true,
                            useHTML: true,
                            crop: false
                        }
                    },
                ],                                        
                yAxis: {
                    title: {
                        text: ''
                    },
                    categories: [
                    'Clerks of the Senate',
                    'Clerks of the House of Representatives',
                    'Principal Parliamentary Reporters', 
                    'Joint House Department Secretaries', 
                    'Department of Parliamentary Services Secretaries',
                    'Parliamentary Librarians',
                    'Parliamentary Budget Officers'
                    ],
                    labels: {
                        y: -1950
                    }
                },
                
            }
        }
    },
    data() {
        return {
            title: 'Parliamentary office holders timeline',
            clerksSenate: [],
            clerksReps: [],
            parliamentaryReporters: [],
            jointHouseSecretaries: [],
            parliamentaryServiceSecretaries: [],
            parliamentaryLibrarians: [],
            parliamentaryBudgetOfficers: [],
            loading: true
        }
    }
}
</script>

<style lang="stylus" scoped>

    #timeline >>> div {
        overflow: visible !important;
    }

    #timeline >>> .highcharts-container {
        overflow: visible !important;
    }

    #timeline >>> .highcharts-container svg {
        overflow: visible !important;
    }

    #timeline >>> .highcharts-tooltip span {
        background-color: transparent;
    }

    #timeline >>> .highcharts-yaxis-labels text {
        cursor: pointer !important;
    }


    #timeline >>> .timeline-label {
        text-decoration: none; color: black;
    }

</style>